import * as React from "react";
import { FeatureToggle } from "client/resources/featureFlagsResource";
import SimpleDataTable from "components/SimpleDataTable/SimpleDataTable";
import styles = require("./style.less");
import OpenDialogButton from "../../components/Dialog/OpenDialogButton";
import EditFeatureFlagScopeDialog from "./EditFeatureFlagScopeDialog";
import { HostedInstanceLookupResource } from "../../client/resources/hostedInstanceLookupResource";
import { ReefResource } from "../../client/resources/reefResource";
import SwitchWithConfirmation from "./SwitchWithConfirmation";
import ExternalLink from "../../components/Navigation/ExternalLink";

class DataTable extends SimpleDataTable<FeatureToggle> {
}

interface Props {
    featureFlags: FeatureToggle[];
    editFeatureFlag: (featureFlag: FeatureToggle) => Promise<void>;
    instances: HostedInstanceLookupResource[];
    reefs: ReefResource[];
    onFeatureFlagSave(): Promise<boolean>;
}

class FeatureFlagsDataTable extends React.Component<Props> {
    render() {
        return (
            <DataTable
                data={this.props.featureFlags}
                onRow={this.buildRow}
                headerColumns={["Feature Name", "Enabled", "Scope", "Min. version", ""]}
                rowColumnClassName={styles.dataTableRowColumn}
            />
        );
    }

    private buildRow = (featureFlag: FeatureToggle) => {
        const onToggle = (isInputChecked: boolean) => {
            return this.props.editFeatureFlag({
                ...featureFlag,
                IsEnabled: isInputChecked
            });
        };

        const columns = [
            <>{featureFlag.Name}<ExternalLink href={featureFlag.MoreInfoLinkUri}/></>,
            <SwitchWithConfirmation
                value={featureFlag.IsEnabled}
                onChange={onToggle}
                settingName={featureFlag.Name}
                noun="Feature Flag" />,
            this.renderScope(featureFlag),
            featureFlag.AppliesTo.MinimumVersion
        ];

        columns.push(featureFlag.Granularity !== "Global"
            ? <OpenDialogButton label={"Edit scope"}>
                <EditFeatureFlagScopeDialog
                    featureFlag={featureFlag}
                    instances={this.props.instances}
                    reefs={this.props.reefs}
                    onSaveClick={this.props.onFeatureFlagSave} />
              </OpenDialogButton>
            : null);
        return columns;
    }

    private renderScope = (featureFlag: FeatureToggle) => {
        const exclusionCount = featureFlag.AppliesTo.ExcludedInstanceIds.length;
        const exclusionString = exclusionCount > 0 ? ` | -${exclusionCount} instance(s)` : "";
        switch (featureFlag.AppliesTo.Scope) {
            case "Global":
                return `Global${exclusionString}`;

            case "Scoped":
                const instanceCount = featureFlag.AppliesTo.InstanceIds.length;
                const reefCount = featureFlag.AppliesTo.ReefIds.length;

                const instanceString = instanceCount > 0 ? `Instance (${instanceCount})` : "";
                const reefString = reefCount > 0 ? `Reef (${reefCount})` : "";
                const separator = instanceCount > 0 && reefCount > 0 ? ", " : "";

                return `${reefString}${separator}${instanceString}${exclusionString}`;

            default:
                return "";
        }
    }
}

export default FeatureFlagsDataTable;